import request from '@/utils/request';
import {async} from "q";

// 获取绑定状态
export async function getMessageOnOfInfo(openId: string) {
    let params = {
        openId
    }
    return request(`/api/wechat/getMessageOnOfInfo`,{
        method: 'POST',
        body: params
    })
}
// 修改状态
export async function updateMessageOnOf(params: any) {
    return request(`/api/wechat/updateMessageOnOf`, {
        method: 'POST',
        body: params
    })
}

// 设备列表
export async function getAppList() {
    let openId=sessionStorage.openId
    return request(`/monitor/client/app/getAppList?type=1&openId=${encodeURIComponent(openId)}`,{})
}

// 应用列表
export async function detailsList(params) {
    let str = `cid=${params.cid}&type=1&openId=${encodeURIComponent(sessionStorage.openId)}`
    return request(`/monitor/client/app/details?${str}`,{})
}
//  保存修改
export async function updateRuns(params) {
    return request('/monitor/client/app/updateRuns',{
        body: params,
        method: 'POST'
    })
}
